import { firebase, firestore } from './firebase';

function findAllUsers() {
    return firestore.collection('users').get();
}

function findUserById(userId) {
    return firestore.collection('users').doc(userId).get();
}

function findUserByBusinessName(businessName) {
    return firestore.collection('users').where('businessName', '==', businessName).get();
}

function findUserByProfilePath(profilePath) {
    return firestore.collection('users').where('profilePath', '==', profilePath).get();
}

function addUser(user) {
    user.joinDate = Date.now();
    user.updatedAt = null;
    return firestore.collection('users').doc(user.userId).set(user);
}

function updateUser(user) {
    user.updatedAt = Date.now();
    return firestore.collection('users').doc(user.userId).set(user);
}

function deleteUser(userId) {
    return firestore.collection('users').doc(userId).delete();
}

function findUIModelServiceById(serviceId) {
    return firestore.collection('ui-models-services').doc(serviceId).get();
}

function findUIModelSpecialisationsByServiceId(serviceId) {
    return firestore.collection('ui-models-specialisations').where('service', '==', serviceId).get();
}

function findUIModelAccreditationsByServiceId(serviceId) {
    return firestore.collection('ui-models-accreditations').where('services', 'array-contains', serviceId).get();
}

function findUIModelIndemnitiesByServiceId(serviceId) {
    return firestore.collection('ui-models-indemnities').where('services', 'array-contains', serviceId).get();
}

function addServiceRequest(serviceRequest) {
    serviceRequest.createdAt = Date.now();
    return firestore.collection('service-requests').add(serviceRequest);
}

function addSurveyReply(surveyReply) {
    surveyReply.createdAt = Date.now();
    surveyReply.updatedAt = null;
    return firestore.collection('survey-replies').add(surveyReply);
}

function addQuoteRequest(quoteRequest) {
    quoteRequest.createdAt = Date.now();
    quoteRequest.updatedAt = null;
    return firestore.collection('quote-requests').add(quoteRequest);
}

function findSchedulesByUserIdAndEndAfter(userId, after) {
    return firestore.collection('schedules').doc(userId).collection('schedules')
        .where('end', '>', after)
        .get()
}

function saveSchedule(userId, schedule) {
    return firestore.collection('schedules').doc(userId).collection('schedules').doc(schedule.id).set(schedule);
}

function deleteSchedule(userId, scheduleId) {
    return firestore.collection('schedules').doc(userId).collection('schedules').doc(scheduleId).delete();
}

const database = {
    findAllUsers,
    findUserById,
    findUserByBusinessName,
    findUserByProfilePath,
    addUser,
    updateUser,
    deleteUser,
    findUIModelServiceById,
    findUIModelSpecialisationsByServiceId,
    findUIModelAccreditationsByServiceId,
    findUIModelIndemnitiesByServiceId,
    addServiceRequest,
    addSurveyReply,
    addQuoteRequest,
    findSchedulesByUserIdAndEndAfter,
    saveSchedule,
    deleteSchedule
};
export default database;